<div class="clock-widget" [class.compact-open]="isCompact() && detailsOpen()">
  @if (!clocksAreOpen()) {
    <button
      type="button"
      class="widget-trigger"
      (click)="toggleVisibility()"
      aria-label="Show timezone clocks"
      [title]="clocks.calendarDateTitle() + ' · Show US timezone clocks'"
      [attr.aria-expanded]="false"
    >
      <span class="trigger-date">{{ clocks.calendarDate() }}</span>
      <app-svg-icons icons="clock" height="17" width="17" aria-hidden="true" />
    </button>
  } @else {
    <div class="widget-content" role="group" aria-label="US timezone clocks">
      <span class="calendar-date" [title]="clocks.calendarDateTitle()" [attr.aria-label]="clocks.calendarDateTitle()">
        <span class="calendar-day" aria-hidden="true">{{ clocks.calendarDay() }}</span>
        <span class="calendar-month" aria-hidden="true">{{ clocks.calendarMonth() }}</span>
      </span>
      @if (isCompact()) {
        <span class="popover-heading">US time zones</span>
      }
      <div class="clocks-row" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="drop($event)">
        @for (tz of readings(); track tz.zone) {
          <div class="tz-chip" cdkDrag [cdkDragData]="tz.zone" [class.is-base]="tz.isBase">
            <button
              type="button"
              class="zone-select"
              (dblclick)="setBaseZone(tz.zone)"
              (keydown)="onZoneKeydown($event, tz.zone)"
              [attr.aria-pressed]="tz.isBase"
              [attr.aria-label]="tz.name + (tz.isBase ? ', selected footer timezone' : ', use as footer timezone')"
              [title]="tz.title + ' Double-click to set as base timezone. Drag to reorder. Keyboard: Enter or Space sets base; Left and Right arrow keys reorder.'"
            >
              <span class="tz-time"
                >{{ tz.time }}<span class="tz-period"> {{ tz.period }}</span></span
              >
              <span class="tz-abbr">{{ tz.abbreviation }}</span>
              @if (tz.dayOffset) {
                <span class="day-offset">{{ tz.dayOffset }}</span>
              }
            </button>
          </div>
        }
      </div>
      <button type="button" class="collapse-btn" (click)="toggleVisibility()" aria-label="Collapse timezone clocks" title="Collapse timezone clocks" [attr.aria-expanded]="true">
        <app-svg-icons icons="minus" height="15" width="15" aria-hidden="true" />
      </button>
    </div>
  }
  <span class="clock-sr-only" aria-live="polite" aria-atomic="true">{{ announcement() }}</span>
</div>
